/**
 * アバター画像のプリロード（体感改善）。
 *
 * users を受け取った時点で avatar_url を new Image() で先読みしてブラウザキャッシュに
 * 入れておく。ピン（Marker）生成時の <img src> はキャッシュから即描画され、
 * 「顔画像が一拍遅れて出る」二次遅延を軽減する。
 *
 * 同一 URL は一度だけプリロードする（?v= が変わると別URL＝再プリロード）。
 */
import type { UserLocation } from '../api/client';

const preloaded = new Set<string>();

/** users のアバター URL をプリロードする（未読のみ）。 */
export function preloadAvatars(users: UserLocation[]): void {
  for (const u of users) {
    const url = u.avatar_url;
    if (!url || preloaded.has(url)) {
      continue;
    }
    preloaded.add(url);
    const img = new Image();
    img.decoding = 'async';
    img.src = url;
  }
}
